var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperSheet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52655 4.44355L5.32655 2.64355H18.6737L20.4737 4.44355V19.5568L18.6737 21.3568H5.32655L3.52655 19.5568V4.44355ZM5.32655 4.44355V19.5568H18.6737V4.44355H5.32655Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1797 7.97187C11.1797 7.39198 11.6498 6.92188 12.2297 6.92188H15.259C15.8389 6.92188 16.309 7.39198 16.309 7.97187C16.309 8.55177 15.8389 9.02187 15.259 9.02187H12.2297C11.6498 9.02187 11.1797 8.55177 11.1797 7.97187Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 7.97187C9.7911 8.55177 9.321 9.02187 8.7411 9.02187C8.1612 9.02187 7.6911 8.55177 7.6911 7.97187C7.6911 7.39198 8.1612 6.92188 8.7411 6.92188C9.321 6.92188 9.7911 7.39198 9.7911 7.97187Z",
    fill: "#208C72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1797 12.0002C11.1797 11.4203 11.6498 10.9502 12.2297 10.9502H15.259C15.8389 10.9502 16.309 11.4203 16.309 12.0002C16.309 12.5801 15.8389 13.0502 15.259 13.0502H12.2297C11.6498 13.0502 11.1797 12.5801 11.1797 12.0002Z",
    fill: "#208C72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 12.0002C9.7911 12.5801 9.321 13.0502 8.7411 13.0502C8.1612 13.0502 7.6911 12.5801 7.6911 12.0002C7.6911 11.4203 8.1612 10.9502 8.7411 10.9502C9.321 10.9502 9.7911 11.4203 9.7911 12.0002Z",
    fill: "#208C72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1797 16.0285C11.1797 15.4486 11.6498 14.9785 12.2297 14.9785H15.259C15.8389 14.9785 16.309 15.4486 16.309 16.0285C16.309 16.6084 15.8389 17.0785 15.259 17.0785H12.2297C11.6498 17.0785 11.1797 16.6084 11.1797 16.0285Z",
    fill: "#208C72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 16.0285C9.7911 16.6084 9.321 17.0785 8.7411 17.0785C8.1612 17.0785 7.6911 16.6084 7.6911 16.0285C7.6911 15.4486 8.1612 14.9785 8.7411 14.9785C9.321 14.9785 9.7911 15.4486 9.7911 16.0285Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperSheet2);
export default __webpack_public_path__ + "static/media/paper-sheet-2.a3fee5754e85a9d13bf390389696713f.svg";
export { ForwardRef as ReactComponent };